import useFileTypeDropdown from './UseFileTypeDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const FileTypeDropdown = ({ label, name, value, error, message, onChange, isPublicFileType=false }) => {
  const { personNationalTeamFileTypeState, arrayData } = useFileTypeDropdown(isPublicFileType);

  return personNationalTeamFileTypeState?.message
    ? <span className={global.LoadingMsg}>{personNationalTeamFileTypeState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={arrayData}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={personNationalTeamFileTypeState?.isArrayLoading}
      />
    );
};

export default FileTypeDropdown;